import {
	SearchFilterActions,
	SearchFilterSelectors,
} from '@/stores/search-filter';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const useSearchFilterParams = (screen: string) => {
	const searchParams = useSelector(
		SearchFilterSelectors.selectSearchFilterParams(screen)
	);

	const { pathname } = useLocation();
	const dispatch = useDispatch();

	// Reset only page for this screen when route changes (e.g. after navigate)
	useEffect(() => {
		return () => {
			dispatch(SearchFilterActions.clearPageOnly({ screen }));
		};
	}, [pathname, screen]);

	const setSearchParams = (params: Record<string, any>) => {
		dispatch(SearchFilterActions.setSearchFilterParams({ screen, params }));
	};

	const clearSearchParams = () => {
		dispatch(SearchFilterActions.clearSearchFilterParams({ screen }));
	};

	/** Clear only `page`; filters and other params are kept. */
	const resetPageOnly = () => {
		dispatch(SearchFilterActions.clearPageOnly({ screen }));
	};

	return [searchParams, setSearchParams, clearSearchParams, resetPageOnly];
};
